import { SurveyorProfile, User } from '../types';

type SurveyorProfileLike = Partial<SurveyorProfile> & Record<string, unknown>;

export const getSurveyorProfile = (user: User | null | undefined): SurveyorProfileLike | null => {
  if (!user) return null;
  return (((user as any).surveyor_profile as SurveyorProfileLike | undefined) ?? (user as any)) || null;
};

export const isSurveyorApproved = (user: User | null | undefined): boolean => {
  const profile = getSurveyorProfile(user);
  if (!profile) return false;
  const status = String(profile.verification_status ?? '').toUpperCase();
  return profile.approved_by_admin === true || status === 'APPROVED' || status === 'VERIFIED';
};

export const isSurveyorSuspended = (user: User | null | undefined): boolean => {
  return getSurveyorProfile(user)?.is_suspended === true;
};

export const getSurveyorServiceTypes = (user: User | null | undefined): string[] => {
  const profile = getSurveyorProfile(user);
  return Array.isArray(profile?.service_types) ? (profile.service_types as string[]) : [];
};
